import React from 'react';
import './NotMatch.css'

const NotMatch = () => {
    return (
        <div className='notmatch'>
            <h1 className='fw-bold text-danger display-1'> Error 404 page not Found </h1>
        </div>
    );
};

export default NotMatch;